import { render } from "./About us.vue?vue&type=template&id=9d048bca&scoped=true"
import script from "./About us.vue?vue&type=script&lang=js"
export * from "./About us.vue?vue&type=script&lang=js"

import "./About us.vue?vue&type=style&index=0&id=9d048bca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d048bca"]])

export default __exports__